/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CheckEscalationResponse } from '../models/CheckEscalationResponse';
import type { StartEscalationRequest } from '../models/StartEscalationRequest';
import type { StartEscalationResponse } from '../models/StartEscalationResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class EscalationService {
    /**
     * Start Escalation
     * Start an escalation flow for a sensitive operation
     * @param requestBody
     * @param userSession
     * @returns StartEscalationResponse Successful Response
     * @throws ApiError
     */
    public static startEscalation(
        requestBody: StartEscalationRequest,
        userSession?: (string | null),
    ): CancelablePromise<StartEscalationResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/escalation/start',
            cookies: {
                'user_session': userSession,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Check Escalation Status
     * Check if escalation is valid for a specific operation
     * @param operation Operation type to check (e.g., 'password_change')
     * @param userSession
     * @returns CheckEscalationResponse Successful Response
     * @throws ApiError
     */
    public static checkEscalation(
        operation: string,
        userSession?: (string | null),
    ): CancelablePromise<CheckEscalationResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/escalation/check',
            cookies: {
                'user_session': userSession,
            },
            query: {
                'operation': operation,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
